import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { AccountDetailsEventFlow, TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

type TrackOutbidViewedPayload = TrackingPayload & {
    eventFlow: AccountDetailsEventFlow;
};

export const trackOutbidViewedAnalytics = (payload: TrackOutbidViewedPayload) => {
    track(TrackingEvents.AuthModal.OutbidViewed, payload);
};

export const useTrackOutbidViewedAnalytics = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(() => {
        trackOutbidViewedAnalytics({
            eventFlow: AccountDetailsEventFlow.Bidding,
            pageName: getAmplitudePageNameFromPath(pathname),
            url,
        });
    }, [pathname, url]);
};
